const audiences = [
  {
    icon: "ri-user-star-line",
    title: "第一次接触系列的人",
    desc: "不清楚有哪些内容、从哪开始，需要一份清晰的目录作为入口。",
  },
  {
    icon: "ri-book-2-line",
    title: "想系统学完的人",
    desc: "希望按阶段循序渐进，而不是零散地东看一课西看一课。",
  },
  {
    icon: "ri-community-line",
    title: "帮别人整理资料的人",
    desc: "需要快速掌握系列结构，方便分享给他人或做学习计划。",
  },
];

export default function Intro() {
  return (
    <section id="intro" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-7">
            <span className="text-xs md:text-sm font-label font-medium tracking-widest text-accent-700 uppercase">
              About the series
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              秘密教学系列，到底是一套怎样的内容
            </h2>
            <div className="mt-5 space-y-4 text-sm md:text-base leading-relaxed text-foreground-700 font-body">
              <p>
                「秘密教学」是一套按课次组织的系列内容，整体上可以理解为一条
                <strong className="font-medium text-foreground-900">
                  从入门到完整
                </strong>
                的学习主线：先建立全局认识，再打牢基础，接着进入进阶技巧与实战演练，
                最后用完整版做一次系统收束。
              </p>
              <p>
                由于系列集数不少、形式也包含视频与图文两类，直接从头翻找容易漏掉内容，
                也不容易判断某一课在整个系列中的位置。因此本站把全部条目按
                <strong className="font-medium text-foreground-900">课程目录</strong>
                的方式重新整理，明确标出课次、主题、时长与所属阶段。
              </p>
              <p>
                你可以把这一页当成系列的「索引页」：先在目录里确认自己要找的是哪一课，
                再到下方的课程导航里按阶段筛选或搜索关键词，快速定位到对应条目。
                全部内容都在本页内，不需要跳转到其他页面。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {audiences.map((item) => (
                <div
                  key={item.title}
                  className="rounded-lg bg-background-100 border border-background-200/70 p-4"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 mb-3">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600 font-body">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20minimal%20desk%20scene%20with%20open%20notebook%20of%20handwritten%20study%20notes%2C%20amber%20table%20lamp%20glow%2C%20clean%20warm%20cream%20background%2C%20editorial%20still%20life%20photography%2C%20soft%20shadows%2C%20calm%20study%20mood&width=1200&height=1000&seq=secret-intro-desk&orientation=portrait"
                alt="整理课程笔记与学习资料的书桌场景"
                className="w-full h-[320px] md:h-[460px] object-cover object-top"
              />
            </div>
            <div className="mt-4 rounded-lg bg-primary-50 border border-primary-200/70 p-4 md:p-5">
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 dark:text-foreground-950">
                  <i className="ri-lightbulb-flash-line text-lg"></i>
                </span>
                <p className="text-xs md:text-sm leading-relaxed text-foreground-800 font-body">
                  小提示：如果时间有限，可以先看「学习路径」一节。那里给出了从导览到完整版的
                  推荐顺序，能帮你判断先看哪几课性价比最高。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}